module.exports = __webpack_public_path__ + "img/reel_area.dd64116b.png";